import React from 'react';

function TrustedSocialMediaAgencySection() {
  const handleOptimizeClick = (e) => {
    e.preventDefault();
    const formEl = document.querySelector('.contact-section') || document.getElementById('contact-form');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="why-need-seo-section">
      <div className="container why-need-seo-container">
        {/* Left Column: Title, Content & CTA Button */}
        <div className="why-need-seo-left">
          <h2 className="why-need-seo-title">
            Your Trusted <span className="why-need-seo-red-title">Social Media Marketing Agency</span> In Pakistan
          </h2>

          <p className="why-need-seo-desc">
            It is very important to connect with the right audience for your business growth. That’s where we are here to help. Our social media management services are your partner in success, helping you reach your ideal customers and drive sales growth. People use these platforms to find the latest and useful products and services with just one click. Consumer behavior has radically shifted online. To truly connect and thrive, your brand doesn’t just need a digital presence; it needs a dynamic social media strategy that converts.
            <br /><br />
            Our social media marketing agency takes advantage of the immense power of social media. Our social media experts are here to provide you with the best strategies that can capture the attention of your audience. We make customized campaigns to leave an impact on your target audience. Your brand is our responsibility, and we make every effort to spread your message far and wide. Partner with Experts and get the best results from our social media marketing services.
          </p>

          <button className="btn-seo-primary" onClick={handleOptimizeClick}>
            Let's Optimize Your Channels
          </button>
        </div>

        {/* Right Column: Social Media Image */}
        <div className="why-need-seo-right">
          <div className="why-need-seo-img-wrapper">
            <img
              src="/assets/images/social-media/social-img3.jpg"
              alt="Your Trusted Social Media Marketing Agency In Pakistan"
              className="why-need-seo-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default TrustedSocialMediaAgencySection;
